import { useState } from "react";
import axios from "axios";
import MainLayout from "../layouts/MainLayout";

function AddClientTicket() {

  const [title,setTitle]=useState("");
  const [description,setDescription]=useState("");

  const saveTicket=async(e)=>{

    e.preventDefault();

    try{

      const token=
      localStorage.getItem("token");

      const clientId=
      localStorage.getItem("client_id");

      console.log(clientId);
      console.log(title);

      const response=await axios.post(

      "https://saleupcall.com/api/add-ticket.php",

      {
        client_id:clientId,
        technician_id: 0,
        manager_id: 0,
        title: title,
        description: description,
        priority: "Medium"
      },

      {
        headers:{
          Authorization:`Bearer ${token}`
        }
      }

      );

      console.log(response.data);

      if(response.data.status){

        alert(
          "Ticket Created : "+
          response.data.ticket_number
        );

        setTitle("");
        setDescription("");

      }
      else{

        alert(
          response.data.message
        );

      }

    }
    catch(error){

      console.log(error);

      alert(
      "Error creating ticket"
      );

    }

  };

  return(

    <MainLayout>

      <div style={{padding:"20px"}}>

        <h2>Create Ticket</h2>

        <form onSubmit={saveTicket}>

          <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e)=>
          setTitle(e.target.value)}
          required
          />

          <br/><br/>

          <textarea
          placeholder="Description"
          value={description}
          onChange={(e)=>
          setDescription(
          e.target.value
          )}
          rows="5"
          required
          />

          <br/><br/>

          <button type="submit">

          Create Ticket

          </button>

        </form>

      </div>

    </MainLayout>

  );

}

export default AddClientTicket;